import DynamicPageRenderer from "../../components/DynamicPageRenderer";

const ZiarraAnnuelles = () => {
  return <DynamicPageRenderer slug="evenements/ziarra" />;
};

export default ZiarraAnnuelles;
